// import { inBrowser } from './env'

export function hasClass (el, className) {
  const reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

export function addClass (el, className) {
  /* istanbul ignore if */
  if (hasClass(el, className)) {
    return
  }

  const newClass = el.className.split(' ')
  newClass.push(className)
  el.className = newClass.join(' ')
}

export function removeClass (el, className) {
  /* istanbul ignore if */
  if (!hasClass(el, className)) {
    return
  }

  const reg = new RegExp('(^|\\s)' + className + '(\\s|$)', 'g')
  el.className = el.className.replace(reg, ' ')
}

export function getData (el, name) {
  const prefix = 'data-'
  return el.getAttribute(prefix + name)
}

export function getRect (ele) {
  function offset (ele) {
    var eleLeft = ele.offsetLeft
    var eleTop = ele.offsetTop
    var eleParent = ele.offsetParent
    var left = null
    var top = null
    left += eleLeft
    top += eleTop
    while (eleParent) {
      left += eleParent.clientLeft + eleParent.offsetLeft
      top += eleParent.clientTop + eleParent.offsetTop
      eleParent = eleParent.offsetParent
    }
    return {left: left, top: top}
  }

  let obj = offset(ele)
  return {
    top: obj.top,
    left: obj.left,
    width: ele.offsetWidth,
    height: ele.offsetHeight
  }
}

let vendor = (() => {
  /* istanbul ignore if */
  // if (!inBrowser) {
  //   return false
  // }
  let elementStyle = document.createElement('div').style
  let transformNames = {
    standard: 'transform',
    webkit: 'webkitTransform',
    Moz: 'MozTransform',
    O: 'OTransform',
    ms: 'msTransform'
  }

  for (let key in transformNames) {
    if (elementStyle[transformNames[key]] !== undefined) {
      return key
    }
  }

  /* istanbul ignore next */
  return false
})()

export function prefixStyle (style) {
  if (vendor === false) {
    return false
  }

  if (vendor === 'standard') {
    if (style === 'transitionEnd') {
      return 'transitionend'
    }
    return style
  }

  return vendor + style.charAt(0).toUpperCase() + style.substr(1)
}

export function getMatchedTarget (e, targetClassName) {
  let el = e.target

  while (el && !hasClass(el, targetClassName)) {
    if (el === e.currentTarget) return null
    el = el.parentNode
  }

  return el
}



// WEBPACK FOOTER //
// ./src/common/js/dom.js